import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TextFieldLabel from "../common/TextFieldLabel";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import { MenuProps } from "app/utils/helper";
import { useQuery } from "react-query";
import { getFeeType } from "app/services/schoolService/newFee.service";
import { useSelector } from "react-redux";
import { selectActiveSession } from "app/modules/schools/selectors";
import { toast } from "react-toastify";

const ByFeeFilter = ({
  showTransportFee = false,
  prevFeeList,
  setSelectedFees,
}) => {
  const [state, setState] = useState({
    feeType: [],
    feeTypeList: prevFeeList,
  });
  const selectedSession = useSelector(selectActiveSession);
  const {
    isLoading: getFeeTypeLoading,
    isFetching: getFeeTypeFetching,
    data: getFeeTypeData,
  } = useQuery({
    queryKey: ["getFeeType"],
    queryFn: () =>
      getFeeType({ isGroupedByClass: "Yes", session: selectedSession }),
    onSuccess: (success) => {
      let updatedFeeTypeList = [];

      if (showTransportFee) {
        updatedFeeTypeList.push({
          feeType: "Transportation Fee",
        });
      }
      updatedFeeTypeList.push(...success?.data?.list);

      if (prevFeeList.length > 0) {
        let checkedUpdatedList = updatedFeeTypeList.map((item) => {
          return {
            ...item,
            checked: prevFeeList.some(
              (prevItem) =>
                prevItem.feeType === item.feeType && prevItem?.checked === true,
            ),
          };
        });
        setState((prev) => ({
          ...prev,
          feeTypeList: checkedUpdatedList,
        }));
      } else {
        if (showTransportFee) {
          setState((prev) => ({
            ...prev,
            feeTypeList: [
              { feeType: "Transportation Fee" },
              ...success?.data?.list,
            ],
          }));
        } else {
          setState((prev) => ({
            ...prev,
            feeTypeList: [...success?.data?.list],
          }));
        }
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
  });
  useEffect(() => {
    setSelectedFees(state.feeTypeList);
  }, [state.feeTypeList]);

  return (
    <>
      <Grid container spacing={1.5}>
        <Grid item xs={12}>
          <TextFieldLabel title={"Select Fee Type"} />
          <CustomSelectBox
            MenuProps={MenuProps}
            multiple
            displayEmpty
            size="small"
            fullWidth
            value={state.feeType}
            renderValue={() => {
              const selected = state.feeTypeList?.filter(
                (item) => item?.checked,
              );
              const total = state.feeTypeList?.length ?? 0;
              if (!selected || selected.length === 0)
                return (
                  <Typography sx={{ color: "text.secondary" }}>
                    Select
                  </Typography>
                );
              if (selected.length === total)
                return (
                  <Typography sx={{ fontWeight: 600 }}>
                    All Fee Types
                  </Typography>
                );
              return (
                <Typography sx={{ fontWeight: 600 }}>
                  {selected.length} Fee Type
                  {selected.length > 1 ? "s" : ""} Selected
                </Typography>
              );
            }}
          >
            {/* Select All row */}
            <Box
              sx={{
                px: 1,
                borderBottom: "1px solid",
                borderColor: "divider",
                mb: 0.5,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    checked={
                      state.feeTypeList?.length > 0 &&
                      state.feeTypeList?.every((item) => item?.checked)
                    }
                    indeterminate={
                      state.feeTypeList?.some((item) => item?.checked) &&
                      !state.feeTypeList?.every((item) => item?.checked)
                    }
                    onChange={(e) => {
                      setState((prev) => ({
                        ...prev,
                        feeTypeList: prev.feeTypeList.map((item) => ({
                          ...item,
                          checked: e.target.checked,
                        })),
                      }));
                    }}
                  />
                }
                label="Select All"
                componentsProps={{
                  typography: { fontSize: "14px", fontWeight: 700 },
                }}
              />
            </Box>
            {state.feeTypeList?.map((item, i) => (
              <Box key={i} sx={{ px: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="secondary"
                      checked={item?.checked ?? false}
                      onChange={() => {
                        setState((prev) => ({
                          ...prev,
                          feeTypeList: prev.feeTypeList.map((f, idx) =>
                            idx === i ? { ...f, checked: !f.checked } : f,
                          ),
                        }));
                      }}
                    />
                  }
                  label={item?.feeType}
                  componentsProps={{
                    typography: {
                      fontSize: "14px",
                      fontWeight: 600,
                    },
                  }}
                />
              </Box>
            ))}
          </CustomSelectBox>
        </Grid>
      </Grid>
    </>
  );
};

export default ByFeeFilter;
